import usePolicyEditPanelManager from "hooks/policy/usePolicyEditPanelManager";
import { PolicyEditPanelType } from "store/policyEditPanelManagementSlice";
import AddTemplatePanel from "./AddTemplatePanel";
import PolicyCriteriaEditPanel from "../criteria/PolicyCriteriaEditPanel";
// import PolicyTemplatePropertiesPanel from "../templates/PolicyTemplatePropertiesPanel";

function PolicyEditPanelOverlay() {
  const { openedPanel, closePanel } = usePolicyEditPanelManager();

  return (
    <>
      {openedPanel === PolicyEditPanelType.AddTemplate && (
        <AddTemplatePanel closePanel={closePanel} />
      )}
      {openedPanel === PolicyEditPanelType.EditCriteria && (
        <PolicyCriteriaEditPanel 
          isOpen
          onDismiss={closePanel}
        />
      )}
      {/* TODO: Uncomment when template properties editing is implemented
      {openedPanel === PolicyEditPanelType.TemplateProperties && (
        <PolicyTemplatePropertiesPanel 
          closePanel={closePanel} 
          policyId={policyId} 
          revisionId={revisionId} 
        />
      )}
      */}
    </>
  );
}

export default PolicyEditPanelOverlay;